import * as config from '../../config.js';

const save_load_adapter = {
    charts: [],
    studyTemplates: [],
    drawingTemplates: [],
    chartTemplates: [],

    getAllCharts: function () {
        config.debugMode && console.log('[Chart] getAllCharts called.')
        return Promise.resolve(this.charts);
    },

    removeChart: function (id) {
        config.debugMode && console.log('[Chart] removeChart called with id: ', id);
        for (var i = 0; i < this.charts.length; ++i) {
            if (this.charts[i].id === id) {
                this.charts.splice(i, 1);
                return Promise.resolve();
            }
        }

        config.debugMode && console.log('[Chart] removeChart rejected ', id);
        return Promise.reject();
    },

    saveChart: function (chartData) {
        config.debugMode && console.log('[Chart] saveChart called with chartData: ', chartData);

        if (!chartData.id) {
            chartData.id = Math.random().toString();
        } else {
            this.removeChart(chartData.id);
        }

        this.charts.push(chartData);

        return Promise.resolve(chartData.id);
    },

    getChartContent: function (id) {
        config.debugMode && console.log('[Chart] getChartContent called with id: ', id)
        for (var i = 0; i < this.charts.length; ++i) {
            if (this.charts[i].id === id) {
                return Promise.resolve(this.charts[i].content);
            }
        }

        config.debugMode && console.log('[Chart] getChartContent Error with id: ', id);
        return Promise.reject();
    },

    removeStudyTemplate: function (studyTemplateData) {
        config.debugMode && console.log('[Chart] removeStudyTemplate called with studyTemplateData: ', studyTemplateData);
        for (var i = 0; i < this.studyTemplates.length; ++i) {
            if (this.studyTemplates[i].name === studyTemplateData.name) {
                this.studyTemplates.splice(i, 1);
                return Promise.resolve();
            }
        }
        config.debugMode && console.log('[Chart] removeStudyTemplate rejected, studyTemplateData: ', studyTemplateData);
        return Promise.reject();
    },

    getStudyTemplateContent: function (studyTemplateData) {
        config.debugMode && console.log('[Chart] getStudyTemplateContent called with studyTemplateData', studyTemplateData);
        for (var i = 0; i < this.studyTemplates.length; ++i) {
            if (this.studyTemplates[i].name === studyTemplateData.name) {
                return Promise.resolve(this.studyTemplates[i]);
            }
        }

        config.debugMode && console.log('[Chart] getStudyTemplateContent rejected studyTemplateData', studyTemplateData);
        return Promise.reject();
    },

    saveStudyTemplate: function (studyTemplateData) {
        config.debugMode && console.log('[Chart] saveStudyTemplate called with studyTemplateData: ', studyTemplateData);
        for (var i = 0; i < this.studyTemplates.length; ++i) {
            if (this.studyTemplates[i].name === studyTemplateData.name) {
                this.studyTemplates.splice(i, 1);
                break;
            }
        }

        this.studyTemplates.push(studyTemplateData);
        return Promise.resolve();
    },

    getAllStudyTemplates: function () {
        config.debugMode && console.log('[Chart] getAllStudyTemplates called.')
        return Promise.resolve(this.studyTemplates);
    },

    removeDrawingTemplate: function (toolName, templateName) {
        config.debugMode && console.log('[Chart] removeDrawingTemplate called with toolName: ', toolName, " and templateName: ", templateName);
        for (var i = 0; i < this.drawingTemplates.length; ++i) {
            if (this.drawingTemplates[i].name === templateName) {
                this.drawingTemplates.splice(i, 1);
                return Promise.resolve();
            }
        }

        config.debugMode && console.log('[Chart] removeDrawingTemplate rejected toolName: ', toolName, " and templateName: ", templateName);
        return Promise.reject();
    },

    loadDrawingTemplate: function (toolName, templateName) {
        config.debugMode && console.log('[Chart] loadDrawingTemplate called with toolName: ', toolName, " and templateName: ", templateName);
        for (var i = 0; i < this.drawingTemplates.length; ++i) {
            if (this.drawingTemplates[i].name === templateName) {
                return Promise.resolve(this.drawingTemplates[i].content);
            }
        }

        config.debugMode && console.log('[Chart] loadDrawingTemplate called with toolName: ', toolName, " and templateName: ", templateName);
        return Promise.reject();
    },

    saveDrawingTemplate: function (toolName, templateName, content) {
        config.debugMode && console.log('[Chart] saveDrawingTemplate called with toolName: ', toolName, " and templateName: ", templateName, " content: ", content);
        for (var i = 0; i < this.drawingTemplates.length; ++i) {
            if (this.drawingTemplates[i].name === templateName) {
                this.drawingTemplates.splice(i, 1);
                break;
            }
        }

        this.drawingTemplates.push({ name: templateName, content: content });
        return Promise.resolve();
    },

    getDrawingTemplates: function () {
        config.debugMode && console.log('[Chart] getDrawingTemplates called.')
        return Promise.resolve(this.drawingTemplates.map(function (template) {
            return template.name;
        }));
    },

    async getAllChartTemplates() {
        config.debugMode && console.log('[Chart] getAllChartTemplates called.')
        return this.chartTemplates.map(x => x.name);
    },

    async saveChartTemplate(templateName, content) {
        config.debugMode && console.log('[Chart] saveChartTemplate called with templateName: ', templateName, " content: ", content);
        const theme = this.chartTemplates.find(x => x.name === templateName);

        if (theme) {
            theme.content = content;
        } else {
            this.chartTemplates.push({ name: templateName, content });
        }
    },

    async removeChartTemplate(templateName) {
        config.debugMode && console.log('[Chart] removeChartTemplate called with tempalteName: ', templateName);
        this.chartTemplates = this.chartTemplates.filter(x => x.name !== templateName);
    },

    async getChartTemplateContent(templateName) {
        config.debugMode && console.log('[Chart] getChartTemplateContent called with templateName: ', templateName);
        const theme = {};

        const content = this.chartTemplates.find(x => x.name === templateName)?.content;

        if (content) {
            theme.content = structuredClone(content);
        }

        return theme
    }
}

export default save_load_adapter;